import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ChatIA} from "../models/chat-ia";
import {environment} from "../../../environments/environment";
import {LoginService} from "./login.service";
import {map} from "rxjs/operators";
import { GeneralService } from "./general.service";

@Injectable()
export class ChatIaService {

  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService,
    private generalService: GeneralService
  ) {
  }

  pullingChatIA(lessonId: number) {
    const headers = this.loginService.getHeaders();
    const url = environment.urlbase + 'ai/lesson-chat/' + lessonId + '/polling';
    return this.httpClient.get<any>(url, { headers: headers }).pipe(
      map(response => {
        // Transform the object-based chatMessagesApp to an array
        const chatMessagesArray = Object.values(response.chatMessagesApp || {});

        return {
          chatMessagesApp: chatMessagesArray,
          showTyping: response.showTyping,
          pollingTime: response.pollingTime
        } as ChatIA;
      })
    );
  }

  getMessageId(lessonId: number, uuid: string) {
    const headers = this.loginService.getHeaders();
    const url = environment.urlbase + 'ai/lesson-chat/' + lessonId + '/response/' + uuid;
    return this.httpClient.get<any>(url, { headers: headers });
  }

  sendMessage(lessonId: number, message: any) {
    const headers = this.loginService.getHeaders();
    const url = environment.urlbase + 'ai/lesson-chat/' + lessonId + '/message';

    return this.httpClient.post<any>(url, message, { headers: headers });
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(key);
  }

}
